import React from 'react';

import { BaseIconProps } from './';

export const PhoneInTalk = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(2.109375,0,0,-2.109375,0,1080)"
    d="m 341,256 h 57 c 0,79 -64,142 -142,142 v -57 c 23,0 44,-9 60,-25 16,-16 25,-37 25,-60 z m 114,0 h 57 c 0,141 -115,256 -256,256 v -57 c 110,0 199,-89 199,-199 z m 28,-100 c -35,0 -69,6 -101,17 -10,3 -21,0 -29,-7 L 290,103 C 210,144 144,210 103,291 l 63,63 c 7,7 10,18 7,28 -11,33 -17,67 -17,102 0,15 -12,28 -28,28 H 28 C 13,512 0,499 0,484 0,216 216,0 484,0 c 15,0 28,13 28,28 v 100 c 0,16 -13,28 -28,28 z"
    fill={fill}
  />
);
